import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/components/WebView/icons/AddNew.svg'


const _withScopeId = n => (_pushScopeId("data-v-cadabffc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Create a new notification"
}, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "text" }
const _hoisted_4 = { class: "icons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackButton = _resolveComponent("BackButton")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_ToggleInput = _resolveComponent("ToggleInput")!
  const _component_Scrollable = _resolveComponent("Scrollable")!
  const _component_WebViewScreen = _resolveComponent("WebViewScreen")!

  return (_openBlock(), _createBlock(_component_WebViewScreen, {
    class: "notification-container",
    "no-pad": "",
    title: "Notifications",
    "disable-when-offline": ""
  }, {
    "left-button": _withCtx(() => [
      _createVNode(_component_BackButton)
    ]),
    "right-button": _withCtx(() => [
      _createElementVNode("div", {
        class: "btn-plus",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onShowCreateNotificationSetting && _ctx.onShowCreateNotificationSetting(...args)))
      }, _hoisted_2)
    ]),
    default: _withCtx(() => [
      (_ctx.settings && _ctx.settings.length)
        ? (_openBlock(), _createBlock(_component_Scrollable, {
            key: 0,
            loading: !_ctx.notificationSettingsLastRefreshed,
            class: "content-container",
            "pull-down": _ctx.reloadNotificationSettings
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.settings, (setting) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: setting.id,
                  ref_for: true,
                  ref: "content",
                  class: "card-content"
                }, [
                  _createElementVNode("div", _hoisted_3, _toDisplayString(setting.name), 1),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_FontAwesomeIcon, {
                      icon: _ctx.faTrashCan,
                      size: "lg",
                      class: "trash-icon",
                      onClick: ($event: any) => (_ctx.confirmDeleteSetting(setting))
                    }, null, 8, ["icon", "onClick"]),
                    _createVNode(_component_ToggleInput, {
                      checked: setting.enabled,
                      "checked-text": "",
                      "un-checked-text": "",
                      size: "mobile",
                      onChange: ($event: any) => (_ctx.toggleSetting(setting))
                    }, null, 8, ["checked", "onChange"])
                  ])
                ]))
              }), 128))
            ], undefined, true),
            _: 1
          }, 8, ["loading", "pull-down"]))
        : _createCommentVNode("", true)
    ], undefined, true),
    _: 1
  }))
}